"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductId = exports.getPkgSlice = exports.getConvertedCurrencies = exports.agentTokenType = exports.agentToken = void 0;

var _appConstants = require("../appConstants");

var _ConfigSelectors = require("./ConfigSelectors/ConfigSelectors");

var getPkgSlice = function getPkgSlice(state) {
  return state[_appConstants.pkgName];
};

exports.getPkgSlice = getPkgSlice;

var agentToken = function agentToken(state) {
  var _state$authentication, _state$authentication2;

  return (_state$authentication = state.authentication) === null || _state$authentication === void 0 ? void 0 : (_state$authentication2 = _state$authentication.agentTokenDetails) === null || _state$authentication2 === void 0 ? void 0 : _state$authentication2.access_token;
};

exports.agentToken = agentToken;

var agentTokenType = function agentTokenType(state) {
  var _state$authentication3, _state$authentication4;

  return (_state$authentication3 = state.authentication) === null || _state$authentication3 === void 0 ? void 0 : (_state$authentication4 = _state$authentication3.agentTokenDetails) === null || _state$authentication4 === void 0 ? void 0 : _state$authentication4.token_type;
};

exports.agentTokenType = agentTokenType;

var getProductId = function getProductId(state) {
  var _state$props, _state$props$topupLis;

  return (_state$props = state.props) === null || _state$props === void 0 ? void 0 : (_state$props$topupLis = _state$props.topupList) === null || _state$props$topupLis === void 0 ? void 0 : _state$props$topupLis.phoneNumber;
};

exports.getProductId = getProductId;

var getConvertedCurrencies = function getConvertedCurrencies(state) {
  return (0, _ConfigSelectors.configSelector)(state).convertedCurrencies;
};

exports.getConvertedCurrencies = getConvertedCurrencies;